import React, { ReactElement, useState } from 'react';
// @ts-ignore
import { Button } from 'react-bootstrap';
import { Breed } from '../../../structures/models/breed';
import { deleteBreed } from '../../../utils/ajax/breedAjax';

type DeleteBreedButtonValues = {
  currentBreed: Breed
};

const DeleteBreedButton: React.FC<DeleteBreedButtonValues> = (props): ReactElement => {
  const {
    currentBreed,
  } = props;

  const [loading, setLoading] = useState(false);
  const disabledSetting = loading ? { disabled: true } : {};

  return (
    <>
      <Button
        {...disabledSetting}
        type="button"
        onClick={(e) => {
          setLoading(true);
          deleteBreed(currentBreed.id)
            .then(() => { setLoading(false); })
            .catch(() => { setLoading(false); });
        }}
        className="btn btn-large btn-danger"
      >
        Delete Breed
      </Button>
    </>
  );
};

export default DeleteBreedButton;
